export default __webpack_public_path__ + "static/media/darkDistraction.ed893adc.png";